export default __webpack_public_path__ + "static/media/privacy-policy.c8530d95.pdf";